import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Checkbox, FormControl, FormControlLabel, Grid, TextField } from '@material-ui/core';
import useRecommendationStyles from './useRecommendationStyles';

export default function GeneralInformation(props) {
  const {
    // senior,
    form,
    setForm,
    formExtra,
    setFormExtra,
    disabled,
    // roles,
    showSendButton,
    handleSendInvitation,
    showResendButton,
    handleResendInvitation,
    closeInvitation,
  } = props;

  const classes = useRecommendationStyles();

  return (
    <Box sx={{ width: '90%', margin: '0 25px 0 20px' }}>
      <Grid container direction="row">
        <Grid item xs={4} sm={3} md={3} lg={2} className={classes.textRowSpacer}>
          <FormControl fullWidth>
            <TextField
              id="salutation"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.salutation}
              onChange={(event) => setForm({ ...form, salutation: event.target.value })}
              disabled={disabled}
              placeholder="Mr, Mrs, Ms..."
              style={{ width: '95%' }}
              inputProps={{ maxLength: 10 }}
              InputProps={{ classes: { input: classes.textField } }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={4} md={4} lg={3} className={classes.textRowSpacer}>
          <FormControl fullWidth>
            <TextField
              id="first-name"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.first_name}
              onChange={(event) => setForm({ ...form, first_name: event.target.value })}
              disabled={disabled}
              placeholder="First Name"
              style={{ width: '95%' }}
              inputProps={{ maxLength: 50 }}
              InputProps={{ classes: { input: classes.textField } }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={5} md={4} lg={3} className={classes.textRowSpacer}>
          <FormControl fullWidth>
            <TextField
              id="last-name"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.last_name}
              onChange={(event) => setForm({ ...form, last_name: event.target.value })}
              disabled={disabled}
              placeholder="Last Name"
              style={{ width: '95%' }}
              inputProps={{ maxLength: 50 }}
              InputProps={{ classes: { input: classes.textField } }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={false} sm={false} md={1} lg={4} />
        <Grid item xs={12} sm={7} md={6} lg={4} className={classes.textRowSpacer}>
          <FormControl fullWidth>
            <TextField
              id="email"
              size="small"
              hiddenLabel
              variant="outlined"
              value={form.email}
              onChange={(event) => setForm({ ...form, email: event.target.value })}
              disabled={disabled}
              placeholder="Email"
              inputProps={{ maxLength: 50 }}
              InputProps={{ classes: { input: classes.textField } }}
            />
          </FormControl>
        </Grid>
        <Grid item xs={false} sm={5} md={false} lg={8} className={classes.textRowSpacer} />
        <Grid item xs={12} sm={7} md={6} lg={4} className={classes.textRowSpacer}>
          <FormControl fullWidth>
            <TextField
              id="relationship"
              size="small"
              hiddenLabel
              variant="outlined"
              value={formExtra.relationship}
              onChange={(event) => setFormExtra({ ...formExtra, relationship: event.target.value })}
              disabled={disabled}
              placeholder="Relation"
              inputProps={{ maxLength: 50 }}
              InputProps={{ classes: { input: classes.textField } }}
            />
          </FormControl>
        </Grid>
        {form.version === 2 && (
          <Grid item xs={12} sm={4} md={4} className={classes.textRowSpacer} style={{ paddingLeft: '30px', marginBottom: 30 }}>
            <FormControlLabel
              style={{ alignItems: 'flex-start' }}
              control={
                <Checkbox
                  color="default"
                  disabled={disabled}
                  checked={formExtra.meetsFhpHousingRequirements ? formExtra.meetsFhpHousingRequirements : false}
                  onChange={() => setFormExtra({ ...formExtra, meetsFhpHousingRequirements: !formExtra.meetsFhpHousingRequirements })}
                />
              }
              label="This recommender is from the FHP program and meets the requirements for FHP Housing recommendation"
            />
          </Grid>
        )}
        {form.version < 2 && (
          <>
            <Grid item xs={12} sm={12} md={12} lg={12} />
            <Grid item xs={12} sm={12} md={4} lg={3} className={classes.textRowLabelSpacer}>
              This request is for (check all that apply):
            </Grid>
            <Grid item xs={12} sm={12} md={8} lg={9} className={classes.textRowSpacer}>
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    disabled={disabled}
                    checked={formExtra.scholarships ? formExtra.scholarships : false}
                    onChange={() => setFormExtra({ ...formExtra, scholarships: !formExtra.scholarships })}
                  />
                }
                label="Scholarships"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    disabled={disabled}
                    checked={formExtra.tradeLife ? formExtra.tradeLife : false}
                    onChange={() => setFormExtra({ ...formExtra, tradeLife: !formExtra.tradeLife })}
                  />
                }
                label="Community Supports"
              />
              <FormControlLabel
                control={
                  <Checkbox
                    color="default"
                    disabled={disabled}
                    checked={formExtra.housing ? formExtra.housing : false}
                    onChange={() => setFormExtra({ ...formExtra, housing: !formExtra.housing })}
                  />
                }
                label="Housing"
              />
            </Grid>
          </>
        )}
        <Grid item xs={false} sm={false} md={6} lg={6} />
        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.buttonSpacer}>
          {showSendButton() && (
            <Button className={classes.buttonWidth} color="primary" variant="contained" onClick={() => handleSendInvitation()}>
              Invite
            </Button>
          )}
          {/*{showResendButton(form.expires_utc) && (*/}
          {/*  <Button className={classes.resendButtonWidth} color="primary" variant="contained" onClick={() => handleResendInvitation()}>*/}
          {/*    Resend Invitation*/}
          {/*  </Button>*/}
          {/*)}*/}
          <div>
            <Button
              className={classes.buttonWidth}
              // style={{ marginLeft: showSendButton() || showResendButton() ? 20 : 0 }}
              color="default"
              variant="contained"
              onClick={() => closeInvitation()}
            >
              {showSendButton() || showResendButton() ? 'Cancel' : 'Close'}
            </Button>
          </div>
        </Grid>
      </Grid>
    </Box>
  );
}

GeneralInformation.propTypes = {
  senior: PropTypes.object,
  form: PropTypes.object,
  setForm: PropTypes.func,
  formExtra: PropTypes.object,
  setFormExtra: PropTypes.func,
  disabled: PropTypes.bool,
  roles: PropTypes.array,
  showSendButton: PropTypes.func,
  handleSendInvitation: PropTypes.func,
  showResendButton: PropTypes.func,
  handleResendInvitation: PropTypes.func,
  closeInvitation: PropTypes.func,
};
